import { INITIAL_ASSIGNMENT_NOTIFICATION_SHOWN } from 'src/constants/local-storage.constants';
import { DEFAULT_IS_ASSIGNMENT_NUMBER_MESSAGE_SHOWN_VALUE } from 'src/constants/messages.constants';

export const resetIsInitialAssignmentsMessageShown = (): void => {
  localStorage.removeItem(INITIAL_ASSIGNMENT_NOTIFICATION_SHOWN);
};

export const saveIsInitialAssignmentsMessageShown = (
  value = DEFAULT_IS_ASSIGNMENT_NUMBER_MESSAGE_SHOWN_VALUE,
): void => {
  localStorage.setItem(INITIAL_ASSIGNMENT_NOTIFICATION_SHOWN, value);
};

export const getIsInitialAssignmentsMessageShown = (): string | null =>
  localStorage.getItem(INITIAL_ASSIGNMENT_NOTIFICATION_SHOWN);
